@use '~/theme/theme' as *;
@use '~/theme/typography';

.title1 {
  @include typography.title1;
}

.title2 {
  @include typography.title2;
}

.title3 {
  @include typography.title3;
}

.title4 {
  @include typography.title4;
}

.subtitle1 {
  @include typography.subtitle1;
  @include typography.semibold;
}

.subtitle2 {
  @include typography.subtitle2;
  @include typography.semibold;
}

.body1 {
  @include typography.body1;
}

.body2 {
  @include typography.body2;
}

.caption {
  @include typography.caption;
}

.tiny {
  @include typography.tiny;
}

.bold {
  @include typography.bold;
}

.semibold {
  @include typography.semibold;
}

.medium {
  @include typography.medium;
}

.regular {
  @include typography.regular;
}

.light {
  @include typography.light;
}

.secondaryColor {
  color: color(grey-600);
}

.tabularNums {
  @include typography.tabular-nums;

  letter-spacing: -0.8px;
  white-space: nowrap;
}

.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.uppercase {
  text-transform: uppercase;
}

.alignLeft {
  text-align: left;
}

.alignCenter {
  text-align: center;
}

.alignRight {
  text-align: right;
}
